<div>
  <h2 [id]="headerID()">
    <button type="button" (click)="toggle()" class="flex items-center justify-between w-full cursor-pointer py-5 font-medium rtl:text-right text-gray-500 dark:text-gray-400 gap-3 hover:text-gray-900 dark:hover:text-white transition-colors" [attr.aria-expanded]="isOpen()" [attr.aria-controls]="bodyID()">
      <ng-content select="header"></ng-content>

      <app-icons icon="chevron-right" class="inline-flex shrink-0 transition-transform duration-300 ease-in-out" [class.rotate-90]="isOpen()"></app-icons>
    </button>
  </h2>
  <div [id]="bodyID()" [attr.aria-labelledby]="headerID()" class="grid transition-all duration-300 ease-in-out" [class.grid-rows-[1fr]]="isOpen()" [class.grid-rows-[0fr]]="!isOpen()">
    <div class="overflow-hidden">
      <div class="py-3">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>

